const getHorisontalPosition = ({
  preferredPosition,
  containerWidth,
  triggerLeft,
  triggerRight,
  menuWidth
}) => {
  const fitsRight = containerWidth - triggerLeft - menuWidth >= 0;
  const fitsLeft = containerWidth - (containerWidth - triggerRight) - menuWidth >= 0;
  if (preferredPosition === "left") {
    return fitsRight ? "left" : fitsLeft ? "right" : (
      // Fits neither right or left, no solution yet, fallback to preferred
      preferredPosition
    );
  }
  return fitsLeft ? "right" : fitsRight ? "left" : (
    // Fits neither right or left, no solution yet, fallback to preferred
    preferredPosition
  );
};
export {
  getHorisontalPosition
};
